<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <gg-card class="fill-height">
          <gg-card-header>
            Select Period
          </gg-card-header>
          <gg-card-text>
            Select a period for the report view.
            <v-menu
                      ref="menu"
                      v-model="menu"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <gg-input-label>Reporting Period</gg-input-label>
                          <v-text-field
                            dense
                            outlined
                            autocomplete="off"
                            prepend-icon="mdi-calendar"
                            readonly
                            :value="formattedDate"
                            v-bind="attrs"
                            v-on="on"
                          />

                        </div>
                      </template>
                      <v-date-picker
                        v-model="date"
                        type="month"
                        no-title
                        scrollable
                        min="2009-01"
                        :max="currentDate"
                        @change="getData"
                      />
                    </v-menu>
          </gg-card-text>
        </gg-card>
      </v-col>

      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            Traffic Detail
          </gg-card-header>
          <gg-card-text>
            <v-data-table :headers="headers" :items="trafficDetails" :loading="pending">
              <template v-slot:item.browser="{ item }">
                <code>{{ item.browser }}</code>
              </template>
            </v-data-table>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import parse from 'date-fns/parse'
import format from 'date-fns/format'

export default {
  name: 'TrafficDetails',
  data: () => ({
    pending: false,
    headers: [
      { text: 'Timestamp', value: 'timestamp' },
      { text: 'Campaign', value: 'campaign' },
      { text: 'Client IP', value: 'ipaddress' },
      { text: 'Referring URL', value: 'referer' },
      { text: 'User Agent (Browser)', value: 'browser' },
    ],
    menu: false,
    date: new Date().toISOString().substr(0, 7),
  }),
  mounted () {
    this.getData()
  },
  computed: {
    ...mapGetters({
      trafficDetails: 'affiliates/trafficDetails'
    }),
    formattedDate () {
      const newDate = parse(this.date, 'yyyy-MM', new Date())
      return format(newDate, 'MMMM yyyy')
    },
    currentDate () {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0')
      return `${currentYear}-${currentMonth}`
    }
  },
  methods: {
    ...mapActions({
      getTrafficDetails: 'affiliates/getTrafficDetails',
      reportError: 'reportError'
    }),
    async getData () {
      try {
        this.pending = true

        await this.getTrafficDetails(this.date)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    },
  }
}
</script>

<style scoped>

</style>
